<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

const props = defineProps({ languages: { type: Array, default: () => [] }, active: { type: String, default: 'en' }, flagUrl: { type: Function, required: true }, t: { type: Function, required: true } });
const emit = defineEmits(['select']);
const root = ref(null);
const open = ref(false);
const selected = computed(() => props.languages.find((option) => option.lang === props.active) || props.languages[0] || { lang: 'en', nativeName: 'English' });

function choose(language) {
  open.value = false;
  emit('select', language);
}

function closeOutside(event) {
  if (!root.value?.contains(event.target)) open.value = false;
}

onMounted(() => document.addEventListener('pointerdown', closeOutside));
onBeforeUnmount(() => document.removeEventListener('pointerdown', closeOutside));
</script>

<template>
  <div ref="root" class="language-picker">
    <button class="mobile-language-toggle" type="button" :aria-expanded="String(open)" :aria-label="t('vueDesktop.label.languageSelection', 'Language selection')" @click="open=!open">
      <i :style="{ backgroundImage: `url(${flagUrl(selected.lang, true)})` }" />
      <span>{{ selected.nativeName || selected.title || selected.lang }}</span>
      <b aria-hidden="true">⌄</b>
    </button>
    <nav class="languages" :class="{ open }" :aria-label="t('vueDesktop.label.languageSelection', 'Language selection')">
      <button
        v-for="option in languages"
        :key="option.lang"
        type="button"
        :class="{ active: option.lang === active }"
        :title="option.title || option.nativeName || option.lang"
        :aria-label="option.title || option.nativeName || option.lang"
        :aria-pressed="String(option.lang === active)"
        :style="{ backgroundImage: `url(${flagUrl(option.lang, option.lang === active)})` }"
        @click="choose(option.lang)"
      />
    </nav>
  </div>
</template>
